import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGenerate = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.48052 2.92214L9.81818 8.065L14.961 10.4027L9.81818 12.7403L7.48052 17.8832L5.14286 12.7403L0 10.4027L5.14286 8.065L7.48052 2.92214ZM7.48052 7.4385L6.54545 9.46759L4.51636 10.4027L6.54545 11.3377L7.48052 13.3668L8.41558 11.3377L10.4447 10.4027L8.41558 9.46759L7.48052 7.4385ZM14.2597 7.59746L13.0816 5.03539L10.5195 3.8572L13.0816 2.68837L14.2597 0.116943L15.4286 2.68837L18 3.8572L15.4286 5.03539L14.2597 7.59746Z",
		fill: "currentColor"
	})
});
export default SvgGenerate;
